import { FeatureIdEnum, FilterIdEnum } from '../../enums';

import { AppRouteConfig } from '../../models';

import { Overall, Queries } from '../../views';

import { ROUTER_CONSTS } from '../router.consts';
import { COMPARE_FILTER_CONFIG } from '../routes.filters';
import { ROUTES_PATHS } from '../routes.paths';

const ANALYTICS_PATHS = Object.assign(ROUTES_PATHS, {
  analytics: 'analytics',
  overall: 'overall',
  queries: 'queries'
});

const ANALYTICS_FILTERS = () => ({
  regularFiltersEnabled: true,
  config: {
    [FilterIdEnum.DATE]: {
      enabled: true,
      mandatory: true
    }
  },
  extra: {
    [COMPARE_FILTER_CONFIG.id]: COMPARE_FILTER_CONFIG
  }
});

export const ANALYTICS_ROUTES: AppRouteConfig[] = [
  {
    name: ROUTER_CONSTS.routes.analytics,
    path: ANALYTICS_PATHS.analytics,
    meta: {
      featureId: FeatureIdEnum.ANALYTICS
    }
  }, {
    name: ROUTER_CONSTS.routes.overall,
    path: ANALYTICS_PATHS.overall,
    component: Overall,
    meta: {
      featureId: FeatureIdEnum.OVERALL,
      filters: ANALYTICS_FILTERS
    }
  }, {
    name: ROUTER_CONSTS.routes.queries,
    path: ANALYTICS_PATHS.queries,
    component: Queries,
    meta: {
      featureId: FeatureIdEnum.QUERIES,
      filters: ANALYTICS_FILTERS
    }
  }
];
